/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MarketGoogleStoreProductUpsertRequest model module.
 * @module model/MarketGoogleStoreProductUpsertRequest
 * @version 1.0
 */
class MarketGoogleStoreProductUpsertRequest {
    /**
     * Constructs a new <code>MarketGoogleStoreProductUpsertRequest</code>.
     * @alias module:model/MarketGoogleStoreProductUpsertRequest
     */
    constructor() { 
        
        MarketGoogleStoreProductUpsertRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MarketGoogleStoreProductUpsertRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MarketGoogleStoreProductUpsertRequest} obj Optional instance to populate.
     * @return {module:model/MarketGoogleStoreProductUpsertRequest} The populated <code>MarketGoogleStoreProductUpsertRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MarketGoogleStoreProductUpsertRequest();

            if (data.hasOwnProperty('dataType')) {
                obj['dataType'] = ApiClient.convertToType(data['dataType'], 'Number');
            }
            if (data.hasOwnProperty('jsonData')) {
                obj['jsonData'] = ApiClient.convertToType(data['jsonData'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MarketGoogleStoreProductUpsertRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MarketGoogleStoreProductUpsertRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['jsonData'] && !(typeof data['jsonData'] === 'string' || data['jsonData'] instanceof String)) {
            throw new Error("Expected the field `jsonData` to be a primitive type in the JSON string but got " + data['jsonData']);
        }

        return true;
    }


}



/**
 * @member {Number} dataType
 */
MarketGoogleStoreProductUpsertRequest.prototype['dataType'] = undefined;

/**
 * @member {String} jsonData
 */
MarketGoogleStoreProductUpsertRequest.prototype['jsonData'] = undefined;






export default MarketGoogleStoreProductUpsertRequest;

